import { createEventAsset } from '@/api/advertiser'
import MaterialSelect from '@/components/material-select/MaterialSelect.vue'

export default {
    components: {
        MaterialSelect,
    },
    props: {
        showEventAssetForm: {
            type: Boolean,
            required: true
        },
        eventAssetModel: {
            type: Object,
            default: () => ({ titles: [] })
        }
    },
    created() {
        // console.log('进入数据',this.eventAssetModel)
         
        //提交的数据
        let advertisers = []
        //需要处理的数据
        let advertisersSelect = []

        this.eventAssetModel.advertisers.forEach( (item,index) => {
            //如果有多字节小程序资产，需要选择
            if (item.apps.length > 1) {
                advertisersSelect.push({id:item.advertiser_id,index: index, advertiser_id:item.out_id, advertiser_name:item.advertiser_name, instance_id: null, path: null, app_id: null, appShow: {}, apps:item.apps})
            } 
            advertisers.push({id:item.advertiser_id, advertiser_id:item.out_id, advertiser_name:item.advertiser_name, instance_id: item.apps[0].instance_id, path: item.apps[0].path, app_id: item.apps[0].id, appShow: item.apps[0]})
        })

        this.advertisersSelect = advertisersSelect
        this.advertisers = advertisers

        // console.log('this.advertisersSelect',this.advertisersSelect)
        // console.log('this.advertisers',this.advertisers)

     },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            corporations: [],
            loading: false,
            actionName: '操作',
            rules: {
                asset_type: [{ required: true, message: '请选择资产类型', trigger: 'change' }],
                event_id: [{ required: true, message: '请选择事件', trigger: 'change' }],
            },

            types: [
                {asset_type: 'MINI_PROGRAME', name: '字节小程序'},
                {asset_type: 'TETRIS_EXTERNAL', name: '建站落地页'},
                {asset_type: 'THIRD_EXTERNAL', name: '三方落地页'},
                {asset_type: 'APP', name: '应用'},
                {asset_type: 'QUICK_APP', name: '快应用'},
            ],
            events: [
                {id: 1000000, name: '付费 + 付费ROI'},
                {id: 1000001, name: '激活 + 关键行为'},
                {id: 1000002, name: '激活 + 关键行为 + 广告变现ROI'},
                {id: 14, name: '付费'},
                {id: 497, name: '付费（完整）'},
                {id: 160, name: '付费ROI'},
                {id: 392, name: '付费-新'},
                {id: 498, name: '付费金额（完整）'},
                {id: 13, name: '注册'},
                {id: 39, name: '次留'},
                {id: 8, name: '激活'},
                {id: 25, name: '关键行为'},
                {id: 110, name: '广告变现ROI'},
            ],
            result: {
                success: [],
                errors: [],
            },
            showResult: false,
            showSubmit: true,
            advertisers: [],
            advertisersSelect: [],
        }
    },
    computed: {
        actType() {
            return this.actionName
        }
    },
    mounted() {
         
    },
    watch: {},
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            let error = ''
            this.advertisers.forEach(element => {
                if (!element.app_id) {
                    error += element.advertiser_id+','
                }
            });

            if (error) {
                error = '广告主：' + error + '需要选择字节小程序'
                return this.$message.error(error)
            }


            const data = Object.assign({}, this.eventAssetModel)
         
            data.advertisers = this.advertisers

            // console.log('提交的数据', data)

            this.result.success = []
            this.result.errors = []

            this.loading = true
            createEventAsset(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.result = res.data
                    //出现弹窗，提示结果不关闭，关闭弹窗，才刷新
                    this.showResult = true
                    // this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
                this.showSubmit = false
            }).catch(() => {
                this.loading = false
                this.showSubmit = true
            })
        },
        closerResult () {
            this.showResult = false
            this.$emit('success')
            this.close()
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showEventAssetForm', false)
        },
        clickPane () {
            // console.log(key);
        },
        changeApp (item, option) {
            const app = option.data.attrs.app
            const index = option.data.attrs.index
            this.advertisers[index].path = app.path
            this.advertisers[index].app_id = app.id
            this.advertisers[index].appShow = app
        },
    }
}
